import { render, staticRenderFns } from "./nextTournament.vue?vue&type=template&id=961f9846&scoped=true"
import script from "./nextTournament.vue?vue&type=script&lang=js"
export * from "./nextTournament.vue?vue&type=script&lang=js"
import style0 from "./nextTournament.vue?vue&type=style&index=0&id=961f9846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961f9846",
  null
  
)

export default component.exports